<div class="container">
  <div class="contenedor-datos-basicos">
    <p class="title-approbe">¿Con que Aliado quieres tu cupo?</p>
    <div class="storeOptionsContainer" id="storeOptionsContainer">
      <div *ngIf="mostrarReferencia === 'mostrarReferencia'">
        <div class="contenedor-texto">
          <mat-form-field appearance="outline">
            <mat-label>Aliado</mat-label>
            <input matInput [value]="aliado" [disabled]="true" />
          </mat-form-field>
        </div>
        <button class="btn btn-azul btn-redondo" (click)="getSelectionFees()">
          Continuar
        </button>
      </div>
      <div
        *ngIf="mostrarReferencia === 'mostrarFormulario'"
        class="storeSelectedContainer"
        id="storeSelectedContainer"
      >
        <label
          for="storeSelected"
          class="storeSelectedLabel"
          id="storeSelectedLabel"
        >
          Elige un convenio
        </label>
        <select
          name="storeSelected"
          id="storeSelectedInput"
          [(ngModel)]="storeSelected"
          class="storeSelectedInput"
          (click)="handleCarouselMaskTutoTimer(false); handleResetBranch()"
        >
          <option [ngValue]="null" disabled selected>
            Selecciona un aliado
          </option>
          <option
            *ngFor="let entry of storesListEntries"
            [ngValue]="entry[1]"
            (click)="handleResetBranch()"
          >
            {{ entry[0] }}
          </option>
        </select>
      </div>
      <div
        class="branchStoreSelectedContainer"
        id="branchStoreSelectedContainer"
        *ngIf="storeSelected !== null"
      >
        <h1
          *ngIf="storeSelected.length <= 3"
          class="storeSelectedLabel"
          id="branchStoreSelectedLabel"
        >
          Elige una sucursal
        </h1>
        <h1
          *ngIf="storeSelected.length > 3"
          class="storeSelectedLabel"
          id="branchStoreSelectedLabel"
        >
          Busca una sucursal
        </h1>
        <div
          class="finderBranchsContainer"
          id="finderBranchsContainer"
          *ngIf="storeSelected.length > 3"
        >
          <input
            type="text"
            [(ngModel)]="branchFinder"
            placeholder="Busca la sucursal"
            class="finderBranchsInput"
            id="finderBranchsInput"
            (ngModelChange)="filteredBranchs()"
            [value]="branchFinder"
            autocomplete="off"
          />
          <ul
            class="finderBranchsList"
            id="finderBranchsList"
            *ngIf="findListBranchs && !selectedBranchStore"
          >
            <li
              class="finderBranchsItem"
              id="finderBranchsItem"
              *ngFor="let storeBranch of findListBranchs"
              [value]="storeBranch"
              [(ngModel)]="selectedBranchStore"
              (click)="getClientSelected(storeBranch)"
            >
              <img [src]="urlImage + '/' + storeBranch.brand + '.png'" alt="" />
              <h2>{{ storeBranch.partnerName }}</h2>
            </li>
          </ul>
        </div>
        <swiper-container
          slides-per-view="auto"
          space-between="16"
          class="carouselContainer"
          slide-to-clicked-slide="true"
          [enabled]="!carouselTuto"
          *ngIf="storeSelected.length <= 3"
        >
          <div
            class="carouselMask"
            id="carouselMask"
            [ngClass]="
              carouselTuto ? 'carouselMaskVisible' : 'carouselMaskInvisible'
            "
            (click)="handleCarouselMaskTuto(false)"
          >
            ← Desliza para seleccionar tu sucursal →
          </div>
          <swiper-slide
            *ngFor="let storeBranch of storeSelected"
            class="slideContent"
          >
            <label class="pill">
              <input
                type="radio"
                name="branchSelection"
                [value]="storeBranch"
                [(ngModel)]="selectedBranchStore"
                (click)="getClientSelected(storeBranch)"
              />
              <div class="pillContent">
                <img
                  [src]="urlImage + '/' + storeBranch.brand + '.png'"
                  alt=""
                />
                <div class="pillTextContent">
                  <h2>Sucursal</h2>
                  <h1>{{ storeBranch.partnerName }}</h1>
                </div>
              </div>
            </label>
          </swiper-slide>
        </swiper-container>
      </div>
    </div>
    <div
      *ngIf="mostrarReferencia === 'mostrarFormulario'"
      class="storeSelectedButtonContainer"
      id="storeSelectedButtonContainer"
    >
      <button
        [disabled]="desabledButton"
        class="storeSelectedButton"
        id="storeSelectedButton"
        (click)="getSelectionFees()"
      >
        Continuar
      </button>
    </div>
  </div>
</div>
